import { gql } from 'Utils/apolloClient'
import InstallmentDataFragment from '../Queries/installmentDataFragment'

const installmentAttachEmailAndSend = gql`
  mutation installmentAttachEmailAndSend($email: String!, $installmentId: ID!, $state: String!) {
    installmentAttachEmailAndSend(input: { email: $email, installmentId: $installmentId, state: $state }) {
      installment {
        ...installmentData
      }
    }
  }

  ${InstallmentDataFragment}
`

export default installmentAttachEmailAndSend
